import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import { NzNotificationService } from "ng-zorro-antd/notification";
import { Observable, retry, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { IAppConfig } from "@gtmhub/env";
import { AppConfigService } from "@webapp/core/app-config/services/app-config.service";
import { ApiEndpointService } from "@webapp/core/app-config/services/api-endpoint.service";
import { LoggingService } from "@webapp/core/logging/services/logging.service";
import { StorageService } from "@webapp/core/storage/services/storage.service";
import { DEFAULT_MAX_RETRIES } from "@webapp/core/http/models/http.models";

@Injectable({ providedIn: "root" })
export class HttpErrorInterceptor implements HttpInterceptor {
  private appConfig: IAppConfig;
  private noLogForResponseWithStatusCodes = [404, 409];
  private loggingService: LoggingService;

  private maxRetries = DEFAULT_MAX_RETRIES;

  constructor(
    private injector: Injector,
    private appConfigService: AppConfigService,
    private apiEndpointService: ApiEndpointService,
    private storageService: StorageService
  ) {
    this.appConfig = this.appConfigService.get();
    this.loggingService = new LoggingService(appConfigService.get().logging, "spa", this.storageService);
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      retry({ count: this.maxRetries, resetOnSuccess: true }),
      catchError((error: HttpErrorResponse) => {
        const nzNotificationService = this.injector.get(NzNotificationService);
        let message = "Something bad happened; please try again later.";
        const title = "HTTP Error";
        if (error.error.message) {
          message = error.error.message;
        }
        const messageId = `HTTP_ERROR_${Math.random() * 200}`;

        nzNotificationService.error(title, message, { nzPlacement: "bottomRight", nzDuration: 5000, nzKey: messageId });

        if (error.error instanceof ErrorEvent) {
          // A client-side or network error occurred. Handle it accordingly.
          console.error("An error occurred:", error.error.message);
        } else {
          // The backend returned an unsuccessful response code.
          // The response body may contain clues as to what went wrong,
          console.error(`Backend returned code ${error.status}, body was: ${error.error}`);
        }

        const shouldLogError =
          error.url !== this.appConfig.logging.endpoint &&
          (!this.apiEndpointService.isApiRequest(error.url) || this.noLogForResponseWithStatusCodes.indexOf(error.status) < 0);

        if (shouldLogError) {
          this.loggingService.logHttpError(error, request);
        }

        return throwError({ ...error, messageId });
      })
    );
  }
  // apparently Unit Tests need to be able to set that to 0
  setMaxRetries(maxRetries: number): void {
    this.maxRetries = maxRetries;
  }
}
